import { ProductTransition } from "@/api/models/product-transition/productTransition.model";
import { ProductTransitionProcessService } from "@/api/services/productTransitionProcess.service";
import { VoipNumberPoolStoreMutations } from "../voipNumberPool";
import { PRODUCT_TRANSITION_PROCESS_CLEAR_ACTION, PRODUCT_TRANSITION_PROCESS_CLEAR_STATE } from "./constants";

const clear = ({ commit }: any) => {
	commit(PRODUCT_TRANSITION_PROCESS_CLEAR_STATE);

	commit(VoipNumberPoolStoreMutations.CLEAR);
};

const createProductTransition = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.create(payload.productId, payload.transition, payload.shoppingCartId)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getProductTransitionById = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.getById(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateProductTransition = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.update(payload.id, payload.data)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const sendProductTransition = ({ commit }: any, id: string) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.send(id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const saveProductTransition = ({ commit }: any, transition: ProductTransition) => {
	commit("setProductTransition", transition);
};

const saveProductTransitionShoppingCartId = ({ commit }: any, shoppingCartId: string) => {
	commit("setProductTransitionShoppingCartId", shoppingCartId);
};

const saveProductTransitionStatus = ({ commit }: any, status: string) => {
	commit("setProductTransitionStatus", status);
};

const getProductTransitionConfiguration = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.getTransitionProcessConfiguration({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const updateTransitionProcessConfiguration = (
	{ commit }: any,
	payload: { productId: string; shoppingCartId: string; bundles: any[]; parameters: any[] }
) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.putTransitionProcessConfiguration(payload)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const getTransitionProcessSummary = ({ commit }: any, { productId, shoppingCartId }: { productId: string; shoppingCartId: string }) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.getTransitionProcessSummary({ productId, shoppingCartId })
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

const deleteProductTransition = ({ commit }: any, payload: any) => {
	return new Promise((resolve, reject) => {
		ProductTransitionProcessService.delete(payload.id)
			.then((response) => {
				resolve(response.data);
			})
			.catch(reject);
	});
};

export default {
	[PRODUCT_TRANSITION_PROCESS_CLEAR_ACTION]: clear,
	createProductTransition,
	getProductTransitionById,
	updateProductTransition,
	sendProductTransition,
	saveProductTransition,
	saveProductTransitionShoppingCartId,
	saveProductTransitionStatus,
	getProductTransitionConfiguration,
	updateTransitionProcessConfiguration,
	getTransitionProcessSummary,
	deleteProductTransition
};
